import { Injectable } from '@angular/core';
import { Review, ReviewReply } from '../../models';
import { ReviewUtils } from '../../utils';
import { AbstractStateService } from '../state/abstract-state.service';
import { PrivateServerCallerService } from '../server-caller/private-server-caller.service';
import { ServerCallerService } from '../server-caller/server-caller.service';
import { ExchangeTokenServerCallerService } from '../server-caller/exchange-token-server-caller.service';

@Injectable({
  providedIn: 'root',
})
export class ReviewService {
  constructor(
    private stateService: AbstractStateService,
    private serverCaller: ServerCallerService,
    private privateServerCallerService: PrivateServerCallerService,
    private exchangeTokenServerCallerService: ExchangeTokenServerCallerService
  ) {}

  public async getAllReviewsOfBusinessObject(
    businessObjectId: number
  ): Promise<Review[]> {
    const url = `/v1/business-object/${businessObjectId}/reviews`;

    const response = await this.privateServerCallerService.get(url);

    return response?.body?.map((review) =>
      ReviewUtils.transformReviewForFrontend(review)
    );
  }

  public async replyReview(
    reviewId: number,
    reviewReply: ReviewReply
  ): Promise<ReviewReply> {
    const url = `/v2/reviews/${reviewId}/replies`;

    const response = await this.privateServerCallerService.post(
      url,
      reviewReply
    );

    return ReviewUtils.transformReviewReplyForFrontend(response?.body);
  }

  public async getReviewByUuid(uuid: string): Promise<Review> {
    const url = `/v1/pending-review/${uuid}/id`;

    const response = await this.serverCaller.get(url);

    return ReviewUtils.transformReviewForFrontend(response?.body);
  }

  public async updateReviewById(review: Review): Promise<boolean> {
    const url = `/v1/pending-review/${review.id}`;

    const response = await this.serverCaller.put(
      url,
      ReviewUtils.transformReviewForBackend(review)
    );

    return response?.status === 200;
  }

  public async createNewReview(boId: number, review: Review): Promise<Review> {
    const url = `/v1/business-object/${boId}/reviews`;

    const response = this.stateService.getToken()
      ? await this.exchangeTokenServerCallerService.post(boId, url, review)
      : await this.serverCaller.post(url, review);

    return response?.body;
  }
}
